import React, { useState, useLayoutEffect, useRef, useEffect } from "react";
import { MdKeyboardArrowDown } from "react-icons/md";
import { homeData } from "services/home";
import { errorResponse, failResponse } from "config/config";
import { Row, Col, Nav } from "react-bootstrap";
import { Link, NavLink, useLocation } from "react-router-dom";

import "../../Normal/CenterMenu.css";

const CenterMenu = () => {
  const [regionalProgram, setRegionalProgram] = useState([]);
  const [loading, setLoading] = useState(true);
  const [onHover, setOnHover] = useState(false);
  const menuRef = useRef();
  const timerRef = useRef(null);

  const location = useLocation();
  const [homePage, sethomePage] = useState(false);


  useEffect(() => {
    sethomePage(location.pathname === '/');
  }, [location.pathname]);


  useLayoutEffect(() => {
    const getHomeData = async () => {
      try {
        setLoading(true);
        const res = await homeData({ type: "home" });

        if (res.code === 200) {
          const sortedRegionalPrograms = res.data.ourPrograms.regional.sort((a, b) => {
            const orderA = a.displayorder !== undefined && a.displayorder !== null && a.displayorder !== "" ? Number(a.displayorder) : Infinity;
            const orderB = b.displayorder !== undefined && b.displayorder !== null && b.displayorder !== "" ? Number(b.displayorder) : Infinity;

 
            if (orderA !== Infinity || orderB !== Infinity) {
              if (orderA !== orderB) {
                return orderA - orderB;
              }
            }

            const regionA = a.region || "";
            const regionB = b.region || "";
            return regionA.localeCompare(regionB);
          });

          setRegionalProgram(sortedRegionalPrograms || []);
        } else {
          failResponse(res);
        }
      } catch (err) {
        errorResponse(err);
      } finally {
        setLoading(false);
      }
    };

    getHomeData();
  }, []);

  const handleMouseEnter = () => {
    clearTimeout(timerRef.current);
    setOnHover(true);
  };

  const handleMouseLeave = () => {
    timerRef.current = setTimeout(() => {
      setOnHover(false);
    }, 200); // Delay before hiding
  };

  useEffect(() => {
    return () => {
      clearTimeout(timerRef.current); // Cleanup on unmount
    };
  }, []);


  return (
    <li
      className={`has-menu ${onHover ? "active" : ""}`}
      ref={menuRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      style={{ position: "relative" }}
    >
      <NavLink to="" className={`nav_link ${homePage ? "nav_link_home" : ""}`}>
        Our Centers{" "}
        <span className="icon">
          <MdKeyboardArrowDown />
        </span>
      </NavLink>

      <div
        className={`megamenu1 ${onHover ? "show" : ""}`}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        style={{
          position: "absolute",
          top: homePage ? "75%" : "70%",
          left: "0",
          zIndex: "1000",
          width: "400px",
          marginTop: "22px",
          backgroundColor: "#fff", // Optional: visually differentiate
          borderRadius: "8px", // Optional styling
          boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
        }}
      >
        <Row className="justify-content-right">
          <Col>
            <Nav className="flex-column">
              {regionalProgram.map((program, index) => (
                <Nav.Item key={index}>
                  <Nav.Link
                    href={`IAS_Institute_${program.region.replace("Shubhra Ranjan IAS Study, ", "")}`}
                  >
                    {program.region}
                  </Nav.Link>
                </Nav.Item>
              ))}
            </Nav>
          </Col>
        </Row>
      </div>
    </li>
  );
};

export default CenterMenu;